class c {
  constructor() {
  }
  validate(e, t) {
    const a = new RegExp(`^[0-9]+([${t}][0-9]{1,2})?$`);
    return !!e.match(a);
  }
}
export {
  c as default
};
